import { getQrConfig } from "../app/UrlCrud";

// The URL a printed label encodes. `baseUrl` is the server-configured public
// origin (ANIKE_PUBLIC_URL); only when that isn't configured do we fall back
// to the origin this page is served from, so local/staging keep working.
// Returns null when there is no token - callers must never render a QR then.
export function buildScanUrl(baseUrl, qrToken) {
    if (!qrToken || typeof qrToken !== "string") return null;
    const base = String(baseUrl || window.location.origin).replace(/\/+$/, "");
    return `${base}/scan/${encodeURIComponent(qrToken)}`;
}

let cachedBaseUrl;
export function loadQrPublicBaseUrl() {
    if (cachedBaseUrl !== undefined) return Promise.resolve(cachedBaseUrl);
    return getQrConfig()
        .then(({ data }) => {
            cachedBaseUrl = (data && data.publicBaseUrl) || null;
            return cachedBaseUrl;
        })
        .catch(() => null);
}

const safeFileName = value => String(value || "asset").replace(/[^a-z0-9_-]+/gi, "-");

function triggerDownload(href, fileName) {
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function serializeSvg(svgEl) {
    const clone = svgEl.cloneNode(true);
    if (!clone.getAttribute("xmlns")) clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    return new XMLSerializer().serializeToString(clone);
}

export function downloadQrSvg(svgEl, assetID) {
    const url = URL.createObjectURL(new Blob([serializeSvg(svgEl)], { type: "image/svg+xml" }));
    triggerDownload(url, `qr-${safeFileName(assetID)}.svg`);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadQrPng(svgEl, assetID, pixels = 1024) {
    return new Promise((resolve, reject) => {
        const svgUrl = URL.createObjectURL(new Blob([serializeSvg(svgEl)], { type: "image/svg+xml" }));
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = pixels;
            canvas.height = pixels;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, pixels, pixels);
            ctx.drawImage(img, 0, 0, pixels, pixels);
            URL.revokeObjectURL(svgUrl);
            canvas.toBlob(blob => {
                if (!blob) return reject(new Error("PNG export failed"));
                const url = URL.createObjectURL(blob);
                triggerDownload(url, `qr-${safeFileName(assetID)}.png`);
                setTimeout(() => URL.revokeObjectURL(url), 1000);
                resolve();
            }, "image/png");
        };
        img.onerror = () => {
            URL.revokeObjectURL(svgUrl);
            reject(new Error("PNG export failed"));
        };
        img.src = svgUrl;
    });
}
